<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import DevicePixelRatio from '@/utils/devicePixelRatio.js';
export default {
  name: "App",
  components: {},
  created() {
    new DevicePixelRatio().init();
  }
};
</script>

<style>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

body {
  font-family: PingFang SC, Helvetica Neue, Helvetica, Arial, Hiragino Sans GB,
    Microsoft Yahei, \\5fae\8f6f\96c5\9ed1, STHeiti, \\534e\6587\7ec6\9ed1,
    sans-serif;
  color: #666;
  font-size: 14px;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: 100%;
  font-weight: 400;
}

li {
  list-style-type: none;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
